import { render, staticRenderFns } from "./paymentPreview.vue?vue&type=template&id=accaf7a4&scoped=true&"
import script from "./paymentPreview.vue?vue&type=script&lang=js&"
export * from "./paymentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accaf7a4",
  null
  
)

export default component.exports